import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  TrendingUp,
  HeartPulse,
  Target,
  PiggyBank,
  Calculator,
  Shield,
  CreditCard,
  Handshake,
  Users,
  Banknote,
  GraduationCap,
  Coins,
} from "lucide-react";

const services = [
  {
    icon: Handshake,
    title: "Terceirização Comercial",
    desc: "Eu contrato o vendedor, crio o processo comercial, treino e acompanho cada um. Você delega a venda e ainda tem garantia de que esse vendedor vai vender.",
    href: "/terceirizacao-comercial",
  },
  {
    icon: Users,
    title: "Recrutamento e Seleção de Pessoas",
    desc: "Eu divulgo a vaga, seleciono, entrevisto, treino e entrego o colaborador pronto para trabalhar. Você não perde tempo com currículo e entrevista.",
    href: "/recrutamento-selecao",
  },
  {
    icon: Banknote,
    title: "Empréstimo Fiserv Capital",
    desc: "Crédito para capital de giro de R$ 10 mil a R$ 500 mil, taxas a partir de 1,89% ao mês, de 6 a 24 meses para pagar e liberação em até 24 horas.",
    href: "/creditorapido",
  },
  {
    icon: GraduationCap,
    title: "Leveduca — Portal de Cursos",
    desc: "Mais de 280 cursos que rodam no celular e no tablet, a preço super acessível. E você acompanha se o time está estudando de verdade.",
    href: "/leveduca",
  },
  {
    icon: TrendingUp,
    title: "Consultoria e Mentorias Empresariais",
    desc: "Crescimento prático em vendas, marketing, pessoas, finanças, vendas online e parcerias. Acompanhamento direto com quem já fez na prática.",
    href: "/consultoria",
  },
  {
    icon: HeartPulse,
    title: "Telemedicina Empresarial",
    desc: "Parceiros oficiais da MediQuo. Cuidado integral da saúde dos seus colaboradores com médicos, psicólogos, nutricionistas e mais — tudo em um app.",
    href: "/telemedicina",
  },
  {
    icon: Target,
    title: "Máquina de Vendas B2B",
    desc: "Montagem completa do departamento comercial: time, processos, scripts, CRM, landing pages e tráfego pago. Do zero ao resultado.",
    href: "/maquina-vendas",
  },
  {
    icon: PiggyBank,
    title: "Gestão Financeira (BPO)",
    desc: "Controle total das suas finanças sem precisar de equipe interna. Relatórios, fluxo de caixa, contas a pagar e receber — tudo organizado.",
    href: "/gestao-financeira",
  },
  {
    icon: Calculator,
    title: "Planejamento Tributário",
    desc: "Reduza impostos de forma legal. Análise completa da sua carga tributária com estratégias personalizadas para o seu negócio.",
    href: "/planejamento-tributario",
  },
  {
    icon: Shield,
    title: "Proteção de Marca",
    desc: "Registre e proteja a identidade do seu negócio. Evite que concorrentes usem seu nome ou sua marca sem autorização.",
    href: "/protecao-marca",
  },
  {
    icon: Coins,
    title: "Monetização de Base de Clientes",
    desc: "Transforme os clientes que você já tem em uma nova fonte de receita. Disponibilizamos 18 produtos e serviços e cuidamos da operação.",
    href: "/monetizacao-base-clientes",
  },
  {
    icon: CreditCard,
    title: "Redução Inteligente de Taxas de Cartão",
    desc: "Analisamos sua operação, negociamos com adquirentes e ajustamos seu CNAE fiscal para garantir as menores taxas do mercado.",
    href: "/reducao-taxas",
  },
];


const ServicesSection = () => (
  <section id="servicos" className="bg-gradient-warm py-16 md:py-24">
    <div className="container">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-12 text-center"
      >
        <span className="mb-3 inline-block rounded-full bg-accent px-4 py-1.5 text-sm font-semibold text-accent-foreground">
          Nossas Soluções
        </span>
        <h2 className="mx-auto max-w-xl text-2xl font-extrabold text-foreground sm:text-3xl md:text-4xl">
          Tudo que sua empresa precisa para{" "}
          <span className="text-gradient-orange">crescer de verdade</span>
        </h2>
      </motion.div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
          >
            <Link
              to={s.href}
              className="group flex h-full flex-col rounded-xl border border-border bg-card p-6 shadow-card transition-all hover:shadow-card-hover hover:-translate-y-1"
            >
              <div className="mb-4 inline-flex rounded-lg bg-accent p-3 self-start">
                <s.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="mb-2 text-lg font-bold text-foreground">{s.title}</h3>
              <p className="flex-1 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
              <span className="mt-4 inline-block text-sm font-semibold text-primary group-hover:underline">
                Saiba mais →
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
